<div class="doc-insidecard">
  <!-- Start code added by Sanchit on 31-03-2026 -->
  <!-- LOADER -->
  <div class="panel-loader" *ngIf="isLoading">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="50"
    ></mat-progress-spinner>
  </div>
  <!-- End code added by Sanchit on 31-03-2026 -->

  <div class="inline-panel" *ngIf="registration">
    <div class="details-content-track">
      <div class="summary-card">
        <div class="summary-wrapper">
          <div class="summary-grid">
            <!-- ROW 1 -->

            <div class="summary-cell">
              <span
                class="summary-overflow-target summary-overflow-target--full"
                (mouseenter)="
                  updateOverflowTitle($event, registration?.workflowName)
                "
                (focusin)="
                  updateOverflowTitle($event, registration?.workflowName)
                "
              >
                <wm-common-text
                  class="label-text"
                  [data]="{ text: registration?.workflowName }"
                >
                </wm-common-text>
              </span>
            </div>

            <div class="summary-cell">
              <wm-common-text
                class="label-text"
                [data]="{ text: 'Company Address:' }"
              >
              </wm-common-text>

              <span
                class="summary-overflow-target"
                (mouseenter)="
                  updateOverflowTitle(
                    $event,
                    registration?.registerApplication?.description
                  )
                "
                (focusin)="
                  updateOverflowTitle(
                    $event,
                    registration?.registerApplication?.description
                  )
                "
              >
                <wm-common-text
                  class="value-text"
                  [data]="{
                    text: registration?.registerApplication?.description
                  }"
                >
                </wm-common-text>
              </span>
            </div>

            <div class="summary-cell">
              <wm-common-text
                class="label-text"
                [data]="{ text: 'Registered On:' }"
              >
              </wm-common-text>

              <wm-common-text
                class="value-text"
                [data]="{ text: registration?.registeredOnString }"
              >
              </wm-common-text>
            </div>

            <div class="summary-cell">
              <wm-common-text class="label-text" [data]="{ text: 'Email:' }">
              </wm-common-text>

              <!-- Added by Amisha on 2026-06-29.
                   Reason: Janus details should display the resolved applicant email from
                   "apply on behalf" custom fields rather than the staff creator name. -->
              <span
                class="summary-overflow-target"
                (mouseenter)="updateOverflowTitle($event, applicantEmail)"
                (focusin)="updateOverflowTitle($event, applicantEmail)"
              >
                <wm-common-text
                  class="value-text"
                  [data]="{ text: applicantEmail }"
                >
                </wm-common-text>
              </span>
            </div>

            <!-- ROW 2 -->

            <div class="summary-cell">
              <wm-common-text
                class="label-text"
                [data]="{ text: 'Renewal Application Number:' }"
              >
              </wm-common-text>

              <span
                class="summary-overflow-target"
                (mouseenter)="
                  updateOverflowTitle(
                    $event,
                    registration?.registerApplication?.combinedApplicationNumber
                  )
                "
                (focusin)="
                  updateOverflowTitle(
                    $event,
                    registration?.registerApplication?.combinedApplicationNumber
                  )
                "
              >
                <wm-common-text
                  class="value-text"
                  [data]="{
                    text:
                      registration?.registerApplication
                        ?.combinedApplicationNumber
                  }"
                >
                </wm-common-text>
              </span>
            </div>

            <div class="summary-cell">
              <wm-common-text
                class="label-text"
                [data]="{ text: 'Amount Paid:' }"
              >
              </wm-common-text>

              <span
                class="summary-overflow-target"
                (mouseenter)="updateOverflowTitle($event, amountPaidDisplay)"
                (focusin)="updateOverflowTitle($event, amountPaidDisplay)"
              >
                <wm-common-text
                  class="value-text"
                  [data]="{ text: amountPaidDisplay }"
                >
                </wm-common-text>
              </span>
            </div>

            <div class="summary-cell">
              <wm-common-text
                class="label-text"
                [data]="{ text: 'Approved On:' }"
              >
              </wm-common-text>

              <wm-common-text
                class="value-text"
                [data]="{ text: registration?.modifiedOn | date: 'MM/dd/yyyy' }"
              >
              </wm-common-text>
            </div>

            <div class="summary-cell">
              <wm-common-text class="label-text" [data]="{ text: 'Phone:' }">
              </wm-common-text>

              <!-- Added by Amisha on 2026-06-29.
                   Reason: Janus details should display the resolved applicant phone from
                   "apply on behalf" custom fields when it exists on the registration. -->
              <span
                class="summary-overflow-target"
                (mouseenter)="updateOverflowTitle($event, applicantPhone)"
                (focusin)="updateOverflowTitle($event, applicantPhone)"
              >
                <wm-common-text
                  class="value-text"
                  [data]="{ text: applicantPhone }"
                >
                </wm-common-text>
              </span>
            </div>

            <!-- ROW 3 -->

            <div class="summary-cell">
              <wm-common-text
                class="label-text"
                [data]="{ text: 'Applicant:' }"
              >
              </wm-common-text>

              <!-- Added by Amisha on 2026-06-29.
                   Reason: Janus details should display the resolved applicant name from
                   "apply on behalf" custom fields rather than the staff creator name. -->
              <span
                class="summary-overflow-target"
                (mouseenter)="updateOverflowTitle($event, applicantName)"
                (focusin)="updateOverflowTitle($event, applicantName)"
              >
                <wm-common-text
                  class="value-text"
                  [data]="{ text: applicantName }"
                >
                </wm-common-text>
              </span>
            </div>

            <div class="summary-cell">
              <wm-common-text
                class="label-text"
                [data]="{ text: 'Application Created:' }"
              >
              </wm-common-text>

              <wm-common-text
                class="value-text"
                [data]="{ text: registration?.createdOn | date: 'MM/dd/yyyy' }"
              >
              </wm-common-text>
            </div>

            <div class="summary-cell">
              <wm-common-text
                class="label-text"
                [data]="{ text: 'Expires On:' }"
              >
              </wm-common-text>

              <wm-common-text
                class="value-text"
                [data]="{ text: registration?.expiresOnString }"
              >
              </wm-common-text>
            </div>
          </div>

          <!-- Added by Amisha on 2026-06-16.
               Reason: match the Renewals Janus details status treatment to the applicant mobile icon pattern
               while keeping the change local to this Janus-only details card. -->
          <div class="status-container">
            <div
              class="status-indicator"
              [attr.aria-label]="getStatusMeta(registration?.status).text"
              [attr.title]="getStatusMeta(registration?.status).text"
            >
              <mat-icon
                class="status-indicator-icon"
                [style.color]="getStatusMeta(registration?.status).color"
              >
                {{ getStatusMeta(registration?.status).icon }}
              </mat-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- ================= TABS ================= -->
      <!-- Start code added by Sanchit on 25-03-2026 -->
      <!-- <div class="tabs">
      <button class="tab-btn" [class.active]="activeTab === 'docs'" (click)="setTab('docs')">
        Compliance Docs
      </button>

      <button class="tab-btn" [class.active]="activeTab === 'fields'" (click)="setTab('fields')">
        Additional Fields
      </button>

      <button class="tab-btn" [class.active]="activeTab === 'notes'" (click)="setTab('notes')">
        Notes
      </button>
    </div> -->

      <!-- <div class="tabs">
        @for (tab of tabs; track tab.id) {
        <div
          class="janus-category-list-button"
          [class.janus-active-category-list-button]="activeTab === tab.id"
        >
          <wm-common-button [data]="getTabButtonData(tab)"> </wm-common-button>
        </div>
        }
      </div> -->
      <!-- End code added by Sanchit on 25-03-2026 -->
       <!-- COde start by Krutika -->
       <div class="tabs-navigation">

  <!-- LEFT ARROW -->
  <button
    *ngIf="showTabArrows"
    type="button"
    class="tabs-arrow"
    aria-label="Scroll tabs left"
    (click)="scrollTabs('left')">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <!-- TABS -->
  <div
    #tabsContainer
    class="tabs"
    (scroll)="updateTabArrows()">

    @for (tab of tabs; track tab.id) {
      <div
        class="janus-category-list-button"
        [class.janus-active-category-list-button]="activeTab === tab.id">

        <wm-common-button
          [data]="getTabButtonData(tab)">
        </wm-common-button>

      </div>
    }

  </div>

  <!-- RIGHT ARROW -->
  <button
    *ngIf="showTabArrows"
    type="button"
    class="tabs-arrow"
    aria-label="Scroll tabs right"
    (click)="scrollTabs('right')">
    <mat-icon>chevron_right</mat-icon>
  </button>

</div>
       <!-- End code by Krutika -->

      <div class="tab-container">
        <wm-compliance-docs
          *ngIf="activeTab === 'docs'"
          [documents]="registration?.documents"
          [workflowName]="registration?.workflowName"
          [parentId]="registration?.id"
          (added)="onComplianceDocsAdded($event)"
          (deleteRequested)="onComplianceDocDeleteRequested($event)"
          (saved)="onComplianceDocSaved($event)"
        >
        </wm-compliance-docs>

        <wm-additional-fields
          *ngIf="activeTab === 'fields'"
          [fields]="registration?.customFields"
        >
        </wm-additional-fields>

        <wm-notes
          *ngIf="activeTab === 'notes'"
          [applicationId]="
            registration?.registerApplicationId || row?.createdApplicationId
          "
          [applicationNumber]="
            registration?.registerApplication?.applicationNumber
          "
        >
        </wm-notes>
      </div>
    </div>
  </div>
</div>
<wm-common-confirmation-modal
  *ngIf="confirmationModalData.open"
  [data]="confirmationModalData"
  (onYesClick)="onConfirmationYes()"
  (onNoClick)="closeConfirmation()"
  (onOkClick)="closeConfirmation()"
  (onCloseClick)="closeConfirmation()"
>
</wm-common-confirmation-modal>
